import update from 'transmute/update';
import { DISMISSED_AT, VIEWED_COUNT } from '../constants/userPromptDataKeyPaths';
export const updateDismissedAt = update(DISMISSED_AT);
export const updateViewedCount = update(VIEWED_COUNT);